import React, { Component } from "react"

import "./contribute.scss"
import contribute from "../../images/contribute.jpg"

class ContributeComponent extends Component {
  render() {
    return (
      <section className="section contribute">
        <div className="content">
          <h3>You can make a difference!</h3>
          <p>Please share info about <span className="redText">Stop Toxic Housing</span> with your friends and <span className="noWrap">on your social media pages!</span></p>
          <p>To support our all-volunteer work for justice, please consider making a tax-deductible donation to Stop Toxic Housing in Pasadena (STHIP), nonprofit charity, a 501c3, <span className="noWrap">(EIN 84-2294403)</span>.</p>
          <div className="address">
            <p>Please <b>mail checks</b> to</p>
            <p>Stop Toxic Housing in Pasadena<br />3579 E Foothill Blvd, Box 231<br /> Pasadena, CA 91107</p>
          </div>
          <img src={contribute} alt="happy family holding hands"/>
          <div className="tagline">
            <div><span>yes to affordable housing</span></div>
            <div><span>no to toxic housing</span></div>
          </div>
        </div>
      </section>
    );
  }
}

export default ContributeComponent
